<template>
  <div class="wrapper">
    <div class="header-wrapper">
      <div class="header">企业广告</div>
      <div class="addManager">
        <Button class="bkcc-btn" @click="goFabu">发布</Button>
      </div>
    </div>
    <!--所属社区-->
    <Card v-if="isJiedao == 1" style="margin: 0 35px 20px 35px;">
      <div class="community-wrapper" v-if="isJiedao == 1">
        <div class="name" style="margin: 20px 0 10px 0">行政区域</div>
        <Select v-model="modelSelect" style="width: 615px" placeholder="请选择行政区域" @on-change="selectCommunity">
          <Option v-for="item in childShequ" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
      </div>
    </Card>
    <div class="content" v-if="org == 'single'">
      <Card :bordered="false" :class="[showList.length?'':'card-wrapper']" :padding="0">
        <div slot="title">

          <div class="advert-remark">广告发布之后可从民生通生活服务展示处进行查看，最多可在此处展示5个，其余在更多广告处查看</div>
        </div>
        <div class="card-con box" v-for="(item, index) in showList" :key="index">
          <div class="box g-img">
            <img :src="item.pic" alt />
          </div>
          <div class="box_f1 g-context">
            <p class="g-title">{{item.title}}</p>
            <p class="g-time">
              <span>{{item.time}}</span>
              <span style="margin-left: 20px">
                <i class="iconfont icon-chakan" style="margin-right: 5px"></i>
                <span>{{item.preNum}}</span>
              </span>
            </p>
          </div>
          <div class="caozuo box_f1 box" style="align-items:center; display: -webkit-flex;">
            <span @click="edit(item.id)">编辑</span>
            <span @click="chehui(item.id)">撤回</span>
            <span @click="gengduo(item.id)">移入更多</span>
            <span v-if="index != 0" @click="sortJian(index)">上移</span>
            <span v-if="index != showList.length-1" @click="sortJia(index)">下移</span>
          </div>
        </div>
        <Spin fix v-if="loading"></Spin>
      </Card>

      <div class="btn-wrapper box">
        <div class="btn" :class="type == 'more'?'active':''" @click="type = 'more' ">更多广告</div>
        <div class="btn" :class="type == 'caogao'?'active':''" @click="type = 'caogao'">草稿</div>
        <div class="btn" :class="type == 'yulan'?'active':''" @click="type = 'yulan'">预览</div>
      </div>

      <div>
        <Table border  :columns="columns" :data="adData" :loading="isTableLoading"></Table>
        <div class="page">
          <page :total="total" @on-change="pageChange" :current="pageNum" @on-page-size-change="changePageSize" :page-size="rows" show-sizer show-total :page-size-opts="[5, 10, 15, 20, 50, 100, 500]"/>
          <Divider type="vertical" />
          <p>
            <span>到</span
            ><Input
              v-model="yema"
              style="width: 60px"
              @on-enter="setpage"
              @on-blur="setpage"
            /><span>页</span>
          </p>
          <span class="tiaozhuan"> 共 <b>{{ total }}</b> 条</span
          >
        </div>
      </div>

    </div>
    <div class="content" v-if="org == 'all'">
      <div>
        <Table border  :columns="columns1" :data="adData" :loading="isTableLoading"></Table>
        <div class="page">
          <page :total="total" @on-change="pageChange" :current="pageNum" @on-page-size-change="changePageSize" :page-size="rows" show-sizer show-total :page-size-opts="[5, 10, 15, 20, 50, 100, 500]"/>
          <Divider type="vertical" />
          <p>
            <span>到</span
            ><Input
              v-model="yema"
              style="width: 60px"
              @on-enter="setpage"
              @on-blur="setpage"
            /><span>页</span>
          </p>
          <span class="tiaozhuan"> 共 <b>{{ total }}</b> 条</span
          >
        </div>
      </div>
    </div>
    <Modal v-model="showDel" title="删除广告" @on-ok="delAdvert">
      <p>确定删除吗？删除后将无法恢复</p>
    </Modal>
  </div>
</template>

<script>
  var that
  export default {
    name: 'advert',
    data () {
      return {
        showList:[],
        type:'more',
        showDel: false,
        modelSelect:'',//选择的行政区域
        childShequ:[],
        loading:false,
        adData:[],
        yema: "",
        isTableLoading:false,
        total:0,
        rows:5,
        pageNum:1,
        delId:'',
        columns: [
          {
            title: "标题",
            key: "title"
          },
          {
            title: "时间",
            key: "time"
          },
          {
            title: "查看数",
            key: "preNum"
          },
          {
            title: "操作",
            render: function(h, params) {
              return h("div", [
                h(
                  "span",
                  {
                    style: {
                      color: "#5e6d94"
                    },
                    on: {
                      click: () => {
                        //   that.toNewVote(params.index);
                        that.edit(params.row.id)
                      }
                    }
                  },
                  "[编辑]"
                ),
                h(
                  "span",
                  {
                    style: {
                      color: "#5e6d94",
                      marginLeft: "10px"
                    },
                    on: {
                      click: () => {
                        that.chehuiOrDel(params.row.id);
                      }
                    }
                  },
                  "["+((that.type=='more' || that.type=='yulan')?'撤回':'删除')+"]"
                )
              ]);
            }
          }
        ],
        columns1: [
          {
            title: "标题",
            key: "title"
          },
          {
            title: "行政区域",
            key: "communityName"
          },
          {
            title: "时间",
            key: "time"
          },
          {
            title: "查看数",
            key: "preNum"
          },
          {
            title: "操作",
            render: function(h, params) {
              return h("div", [
                h(
                  "span",
                  {
                    style: {
                      color: "#5e6d94"
                    },
                    on: {
                      click: () => {
                        //   that.toNewVote(params.index);
                        that.edit(params.row.id)
                      }
                    }
                  },
                  "[编辑]"
                ),
                h(
                  "span",
                  {
                    style: {
                      color: "#5e6d94",
                      marginLeft: "10px"
                    },
                    on: {
                      click: () => {
                        that.chehuiOrDel(params.row.id);
                      }
                    }
                  },
                  "["+(that.type=='more'?'撤回':'删除')+"]"
                )
              ]);
            }
          }
        ],
        org: 'single'
      }
    },
    computed :{
      isJiedao () {
        return parseInt(this.$store.state.isJiedao);
      },
    },
    watch:{
      type () {
        this.pageNum = 1
        this.getAdvertList()
      }
    },
    methods :{
      changePageSize(pageSize) {
        this.rows = pageSize;
        this.getAdvertList()
      },
      setpage() {
        let num = Number(this.yema);
        if (!isNaN(num) && num != 0) {
          this.pageNum = num
          this.getAdvertList()
        }
      },
      getChildShequ () {
        var url = this.urlobj.getChildShequ
        return this.$get(url).then(res => {
          var ids = res.rows.map(item => {
            return item.communityId;
          });
          ids = ids.join(",");
          var item = {
            name: "全部",
            id: ids
          };
          var list = res.rows.map(item => {
            return {
              name: item.communityName,
              id: item.communityId
            };
          });
          list.unshift(item);
          console.log(list);
          this.childShequ = list
          this.modelSelect = ids
          if(this.isJiedao){
            this.org = 'all'
            this.getAllAdvertList()
          } 
        })
      },
      //获取展示公告列表
      getAdvertShowlist () {
        var url = this.urlobj.getAdvert
        var community = this.modelSelect
        var index = String(community).indexOf(',')
        var idlist = index == -1 ? (community?[community]:[]) : community.split(',')
        return this.$post(url,{
          pageNum:1,
          pageSize:5,
          communityIdList:idlist,
          status:1,
        }).then(res => {
          this.showList = res.rows.map(item => {
            return {
              pic: item.coverPicUrl,
              title: item.title,
              time: item.showTime ? item.showTime.substr(0, item.showTime.length - 2) : '',
              preNum: item.previewNumber,
              id: item.id
            };
          });
        })
      },
      //获取更多广告列表
      getAdvertList () {
        var url = this.urlobj.getAdvert
        var community = this.modelSelect
        var index = String(community).indexOf(',')
        var idlist = index == -1 ? (community?[community]:[]): community.split(',')
        return this.$post(url,{
          pageNum:this.pageNum,
          pageSize:this.rows,
          communityIdList:idlist,
          status:this.type == 'more' ? 1 : this.type == 'yulan' ? 4 : 0,
        }).then(res => {
          this.total = res.total
          this.adData = res.rows.map(item => {
            return {
              title: item.title,
              preNum: item.previewNumber,
              time: item.showTime ? item.showTime.substr(0, item.showTime.length - 2) : '',
              id: item.id
            };
          });
        })
      },
      //获取全部广告列表
      getAllAdvertList () {
        var url = this.urlobj.getAdvert
        var community = this.modelSelect
        var index = String(community).indexOf(',')
        var idlist = index == -1 ? [community] : community.split(',')
        return this.$post(url,{
          pageNum:this.pageNum,
          pageSize:10,
          communityIdList:idlist,
          status:3,
        }).then(res => {
          this.total = res.total
          this.adData = res.rows.map(item => {
            return {
              title: item.title,
              preNum: item.previewNumber,
              time: item.showTime ? item.showTime.substr(0, item.showTime.length - 2) : '',
              id: item.id,
              communityName: item.communityName
            };
          });
        })
      },
      goFabu () {
        this.$router.push({name:'advertEdit'})
      },
      // 去编辑
      edit (id) {
        this.$router.push({name:'advertEdit',query:{id}})
      },
      //上移
      sortJian (index) {
        var arr = this.showList,url = this.urlobj.adSort
        arr[index] = arr.splice(index-1, 1, arr[index])[0];
        var idList = arr.map(item => {
          return item.id
        })
        this.$post(url,idList)
      },
      // 下移
      sortJia (index) {
        var arr = this.showList,url = this.urlobj.adSort
        arr[index] = arr.splice(index+1, 1, arr[index])[0];
        var idList = arr.map(item => {
          return item.id
        })
        this.$post(url,idList)
      },
      // 撤回
      chehui (id){
        this.changeAdStatus(id,0)
      },
      //移入更多
      gengduo (id) {
        this.changeAdStatus(id,2)
      },
      //更多列表中 删除或者是撤回
      chehuiOrDel (id) {
        if (this.type == 'more' || this.type == 'yulan') {
          // 撤回
          this.changeAdStatus(id,0)
        }else {
          // 删除
          this.delId = id
          this.showDel = true
        }
      },
      delAdvert () {
        var url = this.urlobj.delAdvert(this.delId)
        this.$delete(url).then(res => {
          this.$Message.success('删除成功')
          this.pageNum = 1
          this.getAdvertList()
        })
      },
      //改变状态 "status" : 发送状态 0--草稿，2--取消公示（历史）,
      changeAdStatus (id,status) {
        var url = this.urlobj.changeAdStatus
        this.$post(url,{
          id,
          status
        }).then(res => {
          this.getAdvertShowlist()
          this.pageNum = 1
          this.getAdvertList()
        })
      },
      // 选择其他社区  初始化数据
      selectCommunity (val) {
        this.pageNum = 1
        var community = val
        var index = String(community).indexOf(',')
        var idlist = index == -1 ? [community] : community.split(',')
        if(idlist.length == 1) {
          this.type = 'more'
          this.getAdvertShowlist()
          this.getAdvertList(2)
          this.org = 'single'
        } else {
          this.getAllAdvertList()
          this.org = 'all'
        }
      },
      // 翻页
      pageChange (num) {
        this.pageNum = num
        var community = this.modelSelect
        var index = String(community).indexOf(',')
        var idlist = index == -1 ? [community] : community.split(',')
        if(idlist.length == 1) {
          this.getAdvertList(2)
        }else {
          this.getAllAdvertList()
        }
      },
    },
    mounted () {
      that = this
      this.getChildShequ()
      if(!parseInt(this.$store.state.isJiedao)){
        this.getAdvertShowlist()
        this.getAdvertList() 
      }
      
    }
  }
</script>

<style scoped lang="less">
  .card-wrapper /deep/ .ivu-card-head{
    border-bottom: none;
  }
  .tiaozhuan {
    margin-left: 10px;
  }
  .wrapper {
    color: #666666;
    overflow: hidden;
    height: 100%;
    /deep/ .ivu-table-wrapper{
      border: none;
    }
    /deep/ th .ivu-table-cell{
      font-weight: 600;
    }
    /deep/ .ivu-table:after{
      display: none;
    }
    /deep/ .ivu-table:before{
      display: none;
    }
    /deep/ .ivu-table th{
      background-color: #f3f4f5;
    }
  }

  .wrapper::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
    /* height: 4px; */
  }
  .header-wrapper {
    display: flex;
    justify-content: center;
    height: 84px;
    line-height: 84px;
    position: relative;
  }
  .header {
    font-size: 25px;
    text-align: center;
  }
  .addManager {
    position: absolute;
    right: 20px;
  }
  .advert-remark{
    font-size: 15px;
    color: #999;
    font-weight: normal;
    margin-top: 20px
  }
  .content {
    //   max-width: 96%;
    margin: 20px;
    margin-top: 0;
    //   margin-left: 40px;
    overflow: hidden;
    //   overflow-y: scroll;
    // background: #fff;
    padding: 0 15px 0 15px;
  }
  .community-wrapper{
    align-items: center;
    .name{
      margin-right: 20px;
    }
  }
  /deep/ .ivu-card-body {
    padding: 0 0 16px 16px;
  }
  .card-con {
    border-bottom: 1px solid #ddd;
    padding: 20px;
  }
  .g-img {
    width: 202px;
    height: 102px;
    border-radius: 5px;
    img {
      width: 202px;
      height: 102px;
    }
  }
  .g-context {
    padding: 10px 20px;
  }
  .g-time {
    margin-top: 40px;
    font-size: 14px;
    color: #999;
  }
  .g-title {
    font-size: 18px;
    color: #333;
  }
  .caozuo span {
    padding: 0 16px;
    border: 1px solid #dedede;
    border-radius: 5px;
    margin-right: 20px;
    font-size: 14px;
    height: 26px;
    line-height: 26px;
  }
  .page {
    width: 100%;
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .btn-wrapper {
    margin:20px 0;
    .btn{
      height: 30px;
      line-height: 30px;
      /*width: 50px;*/
      padding: 0 10px;
      text-align: center;
      background: #fff;
      color:#999;
      &:first-child{
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
      }
      &:last-child{
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
      }
    }
    .active{
      background: #ff7b44;
      color:#fff
    }
  }

</style>
